export const colorConstants = {
	SILVER: '#9B9B9B',
	BLACK: '#000'
};
